import Button from '@mos-cat/button';
import EpicLead from '@mos-cat/epic-lead';
import Heading from '@mos-cat/heading';
import Lead from '@mos-cat/lead';
import Link from '@mos-cat/link';
import List from '@mos-cat/list';
import Paragraph from '@mos-cat/paragraph';

export { Button, EpicLead, Heading, List, Lead, Link, Paragraph };
